var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-goods-amount",
      attrs: {
        title: "修改下单金额",
        visible: _vm.visibleDialog,
        width: "920px",
        top: "calc(50vh - 220px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "goods-con",
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData.items, height: "300px" } },
            [
              _c("el-table-column", {
                attrs: { label: "商品" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "goods-info" }, [
                          _c(
                            "div",
                            { staticClass: "img" },
                            [
                              _c(
                                "el-image",
                                {
                                  staticClass: "pic",
                                  attrs: {
                                    src: scope.row.goodsSkuPic,
                                    fit: "cover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-slot",
                                      attrs: { slot: "error" },
                                      slot: "error",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-picture-outline",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "con" }, [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(scope.row.goodsName)),
                            ]),
                            _c("div", { staticClass: "text" }, [
                              _vm._v(_vm._s(scope.row.goodsSkuName)),
                            ]),
                            _c("div", { staticClass: "text" }, [
                              _vm._v("体积：" + _vm._s(scope.row.volume)),
                              _c("span", { staticClass: "space" }),
                              _vm._v("重量：" + _vm._s(scope.row.weight)),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "编号", width: "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(scope.row.wyGoodsCode || "缺失")),
                        ]),
                        _c("div", { staticClass: "text" }, [
                          _vm._v(
                            "外部编号：" +
                              _vm._s(scope.row.outGoodsCode || "缺失")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价/数量", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("零售价:"),
                            ]),
                            _c(
                              "el-input",
                              {
                                staticClass: "input",
                                attrs: { placeholder: "请输入", size: "mini" },
                                on: { input: _vm.changeTotal },
                                model: {
                                  value: scope.row.goodsPrice,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "goodsPrice", $$v)
                                  },
                                  expression: "scope.row.goodsPrice",
                                },
                              },
                              [
                                _c("template", { slot: "prepend" }, [
                                  _vm._v("￥"),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "row row-top" },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("数"),
                              _c("span", { staticClass: "space" }),
                              _vm._v("量:"),
                            ]),
                            _c("el-input-number", {
                              staticClass: "input",
                              attrs: { min: 1, size: "mini" },
                              on: { change: _vm.changeTotal },
                              model: {
                                value: scope.row.quantity,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "quantity", $$v)
                                },
                                expression: "scope.row.quantity",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "小计", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "total-cell" }, [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(
                              "支付￥" +
                                _vm._s(
                                  _vm.sum(
                                    scope.row.goodsPrice,
                                    scope.row.quantity
                                  )
                                )
                            ),
                          ]),
                          _c("div", { staticClass: "name" }, [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  _vm.sum(
                                    scope.row.marketPrice,
                                    scope.row.quantity
                                  )
                                )
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "total-con" },
            [
              _vm._v(" 总计：共" + _vm._s(_vm.totalNum) + "件"),
              _c("span", { staticClass: "space" }),
              _vm._v(" 商品总价：￥" + _vm._s(_vm.totalAmount)),
              _c("span", { staticClass: "space" }),
              _vm._v(" 运费：￥" + _vm._s(_vm.tableData.totalFreightAmount)),
              _c("span", { staticClass: "space" }),
              _vm._v(" 应付： "),
              _c(
                "el-input",
                {
                  staticClass: "input",
                  attrs: { placeholder: "请输入", size: "mini" },
                  model: {
                    value: _vm.payAmount,
                    callback: function ($$v) {
                      _vm.payAmount = _vm._n($$v)
                    },
                    expression: "payAmount",
                  },
                },
                [_c("template", { slot: "prepend" }, [_vm._v("￥")])],
                2
              ),
              _c("span", { staticClass: "space" }),
              _vm._v(" 已收： "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "input",
                      attrs: { placeholder: "请输入", size: "mini" },
                      model: {
                        value: _vm.hasPay,
                        callback: function ($$v) {
                          _vm.hasPay = _vm._n($$v)
                        },
                        expression: "hasPay",
                      },
                    },
                    [_c("template", { slot: "prepend" }, [_vm._v("￥")])],
                    2
                  ),
                  _c("div", { staticClass: "error" }, [
                    _vm._v(_vm._s(_vm.errorInfo)),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.visibleDialog = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini", loading: _vm.btnLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }